<script setup lang="ts">
const search = defineModel()
const props = defineProps<{
  title: string
  searchLabel: string,
}>()
const platform = useState('platform')


const selectedLocation = ref(null)
if (search.value.coordinates) {
  selectedLocation.value = {
    coordinates: search.value.coordinates,
    value: search.value.value,
  }
}

watch(selectedLocation, function() {
  search.value.coordinates = selectedLocation.value ? selectedLocation.value.coordinates : null
  search.value.value = selectedLocation.value ? selectedLocation.value.value : null
}, {deep: true});

const domainsArray = computed({
  get() {
    return search.value.domain ? search.value.domain.split(',') : [];
  },
  set(newValue) {
    search.value.domain = newValue.join(',');
  }
});
</script>

<template>
  <div class="flex flex-col sm:grid gap-x-10 gap-y-2 sm:items-center my-20 sm:grid-cols-3">
    <div class="text-3xl font-bold text-primary row-span-2" v-html="title"/>
    <div>
      <UFormField :label="searchLabel">
        <UInput v-model="search.q" size="md" class="w-full" placeholder="Votre recherche …" :ui="{ trailing: 'pe-1' }">
          <template v-if="search.q?.length" #trailing>
            <UButton
                color="neutral"
                variant="link"
                size="sm"
                icon="i-ph-x"
                aria-label="Supprimer la recherche"
                @click="search.q = ''"
            />
          </template>
        </UInput>
      </UFormField>
    </div>
    <div>
      <UFormField :label="platform.type === 'city' ? 'Quartier' : 'Ville'">
        <InputNeighborhood v-if="platform.type === 'city'" v-model="selectedLocation" class="w-full" />
        <InputCity v-else v-model="selectedLocation" :types="['place', 'locality', 'postcode']" class="w-full"/>
      </UFormField>
    </div>
    <div class="col-span-2 col-start-2">
      <SearchDomainInput v-model="domainsArray" />
    </div>
  </div>
</template>